export default {
  en: {
    HEADER_URL_PARAMETERS: 'URL Parameters',
    ACTION_CREATE_URL_PARAMETER: 'Create URL Parameter',
    
    PLACEHOLDER_URL_PARAMETER_SEARCH: 'Search URL Parameter',

    MESSAGE_UPDATE_SUCCESS: 'URL Parameter updated',
    MESSAGE_CREATE_SUCCESS: 'URL Parameter created',
    MESSAGE_DELETE_SUCCESS: 'URL Parameter deleted successfully',
    MESSAGE_DUPLICATE_URL_PARAMETER: 'URL Parameter already exists, please enter a unique URL Parameter.',

    //Table
    TABLE_HEADER_COL_URL_PARAMETER: 'URL Parameter',
    TABLE_HEADER_COL_REPORTING_MENU_NAME: 'Reporting Menu Name',
    TABLE_HEADER_COL_REPORT_NAME: 'Report Name',
    INPUT_LABEL_URL_PARAMETER: 'URL Parameter',
    INPUT_LABEL_URL_PARAMETER_TT: 'The URL parameter you\'d like Ringba to tag.',
    INPUT_LABEL_REPORTING_MENU_NAME: 'Reporting Menu Name',
    INPUT_LABEL_REPORTING_MENU_NAME_TT: 'The Menu Option in Reporting under the Tags menu where you can find this data.',
    INPUT_LABEL_REPORT_NAME: 'Report Name',
    INPUT_LABEL_REPORT_NAME_TT: 'The name of the report that will show up in your Menu Name.',
    TT_DELETE: 'Delete URL Param',

    URL_PARAMETERS_TABLE_LOADING: 'Loading URL Parameters',
    URL_PARAMETERS_TABLE_EMPTY: 'You have not created any URL Parameters.',
  
    //Modal
    TITLE_DELETE: 'Delete URL Parameter',
    LABEL_DELETE_MODAL_MESSAGE_CONFIRM_QUESTION: 'Are you sure you want to delete this URL parameter?',
    LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_LOADED: '{name} is currently associated with the following items:',
    LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_ERROR: 'An error occurred while determining associated campaigns, please try again.',
    LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_LOADING: 'Determining if this URL parameter is currently associated with any campaigns.',
    LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_EMPTY: 'The URL parameter is not associated with any campaign.',
    LABEL_DELETE_MODAL_CAMPAIGNS: 'Campaigns',
    TT_VIEW_CAMPAIGN: 'View Campaign',
  }
};